module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/object/define-property.js
// module id = ../node_modules/@babel/runtime/core-js/object/define-property.js
// module chunks = 0